

























































import { ScreenSize } from '@/main/components/constants';

import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'JobCardOperationModal',
	props: {
		visible: { type: Boolean, required: true, default: false },
		serviceAdviserDetails: { type: Object },
	},
	data() {
		return {
			windowWidth: window.innerWidth,
			screenSize: ScreenSize.TABLET,
		};
	},
	computed: {
		visibleCmp: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			},
		},
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		openROiframe(url: string) {
			this.serviceAdviserDetails.isIframeUrl = url;
			this.serviceAdviserDetails.isIframeJobListVisible = true;
		},
	},
});
